import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import {formatDate} from '../../helpers/dates';
import {formatProviderName} from '../../helpers/providers';

const LeadComment = props => (
  <Box>
    <Stack gap={0.25} padding={0.25}>
      <Typography variant='body1'>
        {props?.comment?.content}
      </Typography>
      <Typography variant='caption'>
        {formatProviderName(props?.comment?.author)}
      </Typography>
      <Typography variant='caption'>
        {formatDate(props?.comment?.date_created)}
      </Typography>
    </Stack>
  </Box>
);

LeadComment.propTypes = {
  comment: PropTypes.object.isRequired,
};

export default LeadComment;